{
    "name": "lighthouse-frontend",
    "version": "1.3.9",
     "overrides": {
        "pacote": "^21.0.4",
        "piscina": "^5.3.2",
        "vite": "^7.3.5",
        "undici": "7.29.0",
        "browserslist": "4.28.7",
        "proxy-addr": "^2.0.8"
    },
    "scripts": {
        "ng": "ng",
        "start": "ng serve",
        "build": "node --max_old_space_size=4096 ./node_modules/@angular/cli/bin/ng build --aot --base-href /",
        "watch": "ng build --watch --configuration development",
        "test": "ng test",
        "release": "commit-and-tag-version"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "^21.2.25",
        "@angular/cdk": "^21.2.14",
        "@angular/common": "^21.2.25",
        "@angular/compiler": "^21.2.25",
        "@angular/core": "^21.2.25",
        "@angular/forms": "^21.2.25",
        "@angular/material": "^21.2.14",
        "@angular/platform-browser": "^21.2.25",
        "@angular/platform-browser-dynamic": "^21.2.25",
        "@angular/router": "^21.2.25",
        "@ng-select/ng-select": "^21.8.2",
        "@ngrx/effects": "^21.1.1",
        "@ngrx/store": "^21.1.1",
        "@ngrx/store-devtools": "^21.1.1",
        "@tailwindcss/postcss": "^4.1.7",
        "@types/lodash-es": "^4.17.12",
        "angular-plotly.js": "^6.0.0",
        "date-fns": "^4.1.0",
        "lodash-es": "^4.17.21",
        "ng-animate": "^2.0.1",
        "ngx-mat-select-search": "^8.0.2",
        "plotly.js-dist-min": "^3.0.1",
        "postcss": "^8.5.3",
        "rxjs": "~7.8.0",
        "tabulator-tables": "^6.3.1",
        "tailwindcss": "^4.1.7",
        "tslib": "^2.3.0",
        "zone.js": "~0.15.0"
    },
    "devDependencies": {
        "@angular/build": "^21.2.25",
        "@angular/cli": "^21.2.25",
        "@angular/compiler-cli": "^21.2.25",
        "@ngneat/spectator": "^15.0.1",
        "@types/jasmine": "~5.1.0",
        "@types/plotly.js-dist-min": "^2.3.4",
        "@types/tabulator-tables": "^6.2.6",
        "autoprefixer": "^10.4.21",
        "commit-and-tag-version": "12.7.1",
        "jasmine-core": "~5.6.0",
        "karma": "^6.4.4",
        "karma-chrome-launcher": "~3.2.0",
        "karma-coverage": "^2.2.1",
        "karma-jasmine": "~5.1.0",
        "karma-jasmine-html-reporter": "~2.1.0",
        "postcss": "^8.5.3",
        "typescript": "~5.9.3"
    }
}
